import {AssignedAccountUserReportModel} from '@spa/api';

import {
    ReportTableData,
    ReportTableColumn,
    ReportTableConfigInterface
} from '../../../app/shared/components/report-table';


export const PanelAccountsEditUsersDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: AssignedAccountUserReportModel.getStatusSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: AssignedAccountUserReportModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: AssignedAccountUserReportModel.getUserTypeRelationSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: AssignedAccountUserReportModel.getIsLegalRepresentativeSelector(),
            value: null,
            hidden: false
        }),
    ];
};

export const PanelAccountsEditUsersDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Status',
                selector: AssignedAccountUserReportModel.getStatusSelector(),
            }),
            new ReportTableColumn({
                label: 'Name',
                selector: AssignedAccountUserReportModel.getNameSelector()
            }),
            new ReportTableColumn({
                label: 'Client Type',
                selector: AssignedAccountUserReportModel.getUserTypeRelationSelector()
            }),
            new ReportTableColumn({
                label: 'Type',
                selector: AssignedAccountUserReportModel.getIsLegalRepresentativeSelector()
            })
        ],
        hiddenColumnIds: [],
        actionMenu: false
    };
};
